// Кот-маскот сетевых ошибок: два ассета под темы Vuetify (паттерн репо —
// billing-cat-*.png / billing-cat-*-dark.png). Тёмный — инверсия line-art.
import catLight from "@/assets/network-cat.png";
import catDark from "@/assets/network-cat-dark.png";

export default {
  computed: {
    catImg() {
      return this.$vuetify.theme.dark ? catDark : catLight;
    },
  },
};
